import React from "react";
import Typography from "../../../components/Typography";
import COLORS from "../../../util/constants/colors";
import { Tooltip } from "antd";
import { CALL_OUTCOME_TAG_STYLE, CALL_OUTCOME_TAGS } from "./constants";
import { formatDOB, formatPhoneNumber, formatName } from "../helpers";
import moment from "moment";

// Gated outcomes are redacted to null by the server for orgs without the
// feature, so the outcome cell only needs to tag known values and fall back to
// "No outcome" — no client-side feature gate here.
const outboundColumns = [
  {
    title: 'Patient Name',
    dataIndex: 'patient_name',
    key: 'patient_name',
    render: (name, callLog) => {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography
            variant="text"
            size="small"
            bold
          >
            {formatName(name)}
          </Typography>
          <Typography
            variant="text"
            size="xsmall"
            color={COLORS.TEXT_TERTIARY_LITE}
          >
            {formatDOB(callLog?.patient_dob)}
          </Typography>
        </div>
      )
    },
    fixed: 'left',
  },
  {
    title: 'Phone Number',
    dataIndex: 'phone_number',
    key: 'phone_number',
    render: (text) => (
          <Typography
            variant="text"
            size="small"
            color={COLORS.TEXT_SECONDARY_LITE}
          >
            {formatPhoneNumber(text)}
          </Typography>
    ),
  },
  {
    title: 'Date and Time',
    dataIndex: 'attempt_started_at',
    key: 'attempt_started_at',
    render: (text) => {
      if (!text) {
        return (
          <Typography
            variant="text"
            size="small"
            color={COLORS.TEXT_TERTIARY_LITE}
          >
            --
          </Typography>
        );
      }
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography
            variant="text"
            size="small"
            color={COLORS.TEXT_PRIMARY_LITE}
            bold
          >
            {moment(text).format('MM/DD/YYYY')}
          </Typography>
          <Typography
            variant="text"
            size="small"
            color={COLORS.TEXT_TERTIARY_LITE}
          >
            {moment(text).format('hh:mm A')}
          </Typography>
        </div>
      )
    },
  },
  {
    title: 'Duration',
    dataIndex: 'formatted_attempt_duration',
    key: 'formatted_attempt_duration',
    render: (text, callLog) => {
      const totalCalls = callLog?.total_calls || 0;
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography
            variant="text"
            size="small"
            bold
            color="#7650cd"
            style={{ letterSpacing: 0.4 }}
          >
            {`${totalCalls} ${totalCalls === 1 ? 'call' : 'calls'}`}
          </Typography>
          <Typography
            variant="text"
            size="small"
            color={COLORS.TEXT_PRIMARY_LITE}
            bold
          >
            {text || '00:00'}
          </Typography>
        </div>
      )
    },
  },
  {
    title: 'Workflow',
    dataIndex: 'workflow_name',
    key: 'workflow_name',
    render: (text) => {
      return <Typography variant="text" size="small">{text}</Typography>
    },
  },
  {
    title: 'Call Outcome',
    dataIndex: 'attempt_outcome',
    key: 'attempt_outcome',
    render: (text) => {
      const outcome = CALL_OUTCOME_TAGS[text];
      if (!outcome) {
        return <Typography variant="text" size="small">{text || 'No outcome'}</Typography>;
      }
      return (
        <div style={{
          ...CALL_OUTCOME_TAG_STYLE,
          color: outcome?.color,
          border: `1px solid ${outcome?.color}`,
          backgroundColor: outcome?.backgroundColor,
        }}>
          <span style={{ flexShrink: 0, display: 'flex', alignItems: 'center' }}>{outcome?.icon}</span>
          {outcome?.label}
        </div>
      )
    },
  },
  {
    title: 'Summary',
    dataIndex: 'summary',
    key: 'summary',
    render: (text) => {
      if (!text || text === '[]' || text === '""') {
        return '-';
      }
      return (
        <Tooltip
          title={text}
          placement="bottomLeft"
        >
          <div
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              color: COLORS.TEXT_TERTIARY_LITE,
            }}
          >
            {text}
          </div>
        </Tooltip>
      )
    },
  },
];

export {
  outboundColumns
};
